import { RoutePath } from 'enums/routePath';

const ROOT = `/prospecting`;

const PROSPECTING_BUILD = `${ROOT}/find-opportunities`;
const PROSPECTING_ALL_OPPORTUNITIES = `${ROOT}/all-opportunities`;
const PROSPECTING_OPEN_OPPORTUNITIES = `${ROOT}/open-opportunities`;
const PROSPECTING_SALES_DASHBOARD = `${ROOT}/sales-dashboard`;
const PROSPECTING_CONTRACT_TRACKER = `${ROOT}/contract-tracker`;
const WHITESPACE_ADDITIONS_OVERVIEW = `${ROOT}/product-penetration-overview`;

const paths = {
  [RoutePath.PROSPECTING]: ROOT,
  [RoutePath.WHITESPACE_ADDITIONS_OVERVIEW]: WHITESPACE_ADDITIONS_OVERVIEW,
  [RoutePath.PROSPECTING_BUILD]: PROSPECTING_BUILD,
  [RoutePath.PROSPECTING_ALL_OPPORTUNITIES]: PROSPECTING_ALL_OPPORTUNITIES,
  [RoutePath.PROSPECTING_OPEN_OPPORTUNITIES]: PROSPECTING_OPEN_OPPORTUNITIES,
  [RoutePath.PROSPECTING_SALES_DASHBOARD]: PROSPECTING_SALES_DASHBOARD,
  [RoutePath.PROSPECTING_CONTRACT_TRACKER]: PROSPECTING_CONTRACT_TRACKER,
};

export const pathArray = Object.values(paths);

export default paths;
